import React, { useEffect, useState } from 'react'
import { Btn, CustomDropdown, CustomModal } from '../../../../components'
import { getCities, getUfs } from '../../../../services/api/https/system/system.http'
import { ufIdDoMunicipio } from '../Ciot/ciot.util'

function ModalEncerrarMdfe({ mdfe, isVisible, onCancel, onSave, onError, sugestao = null }) {
  // Vars
  const [state, setState] = useState({
    ufs: [],
    selectedUf: null,
    selectedCity: null,
    cities: [],
  })

  const fetchUFs = async (ufId = null) => {
    await getUfs()
      .then(ufs => {
        if (ufId)
          setState(prevState => ({
            ...prevState,
            ufs: ufs,
            selectedUf: ufs.find(uf => uf.id === ufId),
          }))
        else setState(prevState => ({ ...prevState, ufs: ufs }))
      })
      .catch(err => onError(err))
  }

  const fetchCities = async (ufId, selectedCustomer = null) => {
    await getCities(ufId)
      .then(cities => {
        if (selectedCustomer)
          setState(prevState => ({
            ...prevState,
            cities: cities,
            selectedCity: cities.find(city => city.id === selectedCustomer.city_id),
          }))
        else
          setState(prevState => ({
            ...prevState,
            cities: cities,
          }))
      })
      .catch(err => onError(err))
  }

  // Events
  useEffect(() => {
    if (!isVisible) return
    const loadUfCity = async () => {
      await fetchUFs(sugestao ? ufIdDoMunicipio(sugestao.city_id) : null)
    }
    setState({
      ufs: [],
      selectedUf: null,
      selectedCity: null,
      cities: [],
    })
    loadUfCity()
  }, [isVisible])

  useEffect(() => {
    if (state.selectedUf) fetchCities(state.selectedUf.id, sugestao)
  }, [state.selectedUf])

  if (!mdfe) return null

  const onBtnSalvarClicked = async () => {
    if (!state.selectedUf) return onError('O campo Estado é obrigatório')
    if (!state.selectedCity) return onError('O campo Cidade é obrigatório')
    onSave({ ...mdfe, sigla_uf: state.selectedUf.uf, nome_municipio: state.selectedCity.name })
  }

  // Render
  return (
    <CustomModal header="Encerrar Mdfe" isVisible={isVisible} onClose={onCancel}>
      <form className="p-grid">
        <div className="p-col-4">
          <CustomDropdown
            optionLabel="name"
            options={state.ufs}
            value={state.selectedUf}
            label="Estado :*"
            filter={true}
            onChange={value => {
              setState(prevState => {
                prevState.selectedUf = value
                return { ...prevState }
              })
            }}
          />
        </div>
        <div className="p-col-1"></div>
        <div className="p-col-7">
          <CustomDropdown
            disabled={!state.selectedUf}
            optionLabel="name"
            options={state.cities}
            value={state.selectedCity}
            label="Cidade :*"
            filter={true}
            onChange={value => {
              setState(prevState => {
                prevState.selectedCity = value
                return { ...prevState }
              })
            }}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalEncerrarMdfe
